var DropDownOptions = require("components/utility/DropDownOptions");
var Glyphicon = require("components/utility/icons/Glyphicon");
var CurrentUser = require("lib/account/CurrentUser");
var NumbersOnlyInput = require("components/utility/NumbersOnlyInput");
var ZPDRange = require("lib/academic/ZPDRange");

import moment from 'moment-timezone';
import jstz from 'jstz';


require("reading/books/book_logger.scss");

class BookLogger extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { 
			logRowCount: 1, skipRowIndexes: [], errorsByRow: {}, showDetailedForm: false, 
			selectedLocation: BookLogger.READ_AT_SCHOOL, logMinutes: {}
		};
	}

	shouldExclude() {
		if (!CurrentUser.get().prefs.automatic_zpd_exclusion) {
			return false;
		} else if (!CurrentUser.isStudent()) {
			return false;
		} else if (!this.props.book) {
			return false;
		} else if (!this.props.book.lexile_score) {
			return true;
		} else {
			var zpdStatus = ZPDRange.getTextStatus(
				this.props.book.lexile_score, CurrentUser.get().current_reading_level
			);
			return zpdStatus == ZPDRange.UNDER;
		}
	}
 
	addLogRow() {
		this.setState({ logRowCount: this.state.logRowCount + 1 });
	}

	buildRemoveLogRow(row) {
		return function() {
			this.setState({ skipRowIndexes: this.state.skipRowIndexes.concat([row]),
				logRowCount: this.state.logRowCount - 1});
		}.bind(this);
	}

	removeBook() {
		this.props.removeBook(this.props.book.id);
	}

	onChange(i, e) {
		var key = "log" + i;
		var value =  e.target.value;
		var mergedMinutes = _.extend({}, this.state.logMinutes, { [i]: value })
		this.setState({ logMinutes: mergedMinutes })
	}

	changeDate(row, event) {
		// console.log(row, event.target.value);
	}

	changeLocation(location) {
		this.setState({ selectedLocation: location });	
	}

	validate() {
		var noErrors = true;
		var errors = {};

		for (var i = 0; i < this.state.logRowCount; i++) {
			var minutes = this.refs["log_minutes" + i].refs["textfield"]["valueAsNumber"];
			var pages = this.refs["log_pages" + i].refs["textfield"]["valueAsNumber"];
			var date = this.refs["log_date" + i].value.trim();

			if (this.refs["start_time" + i]) {
				var startTime = this.refs["start_time" + i].value;
				var endTime = this.refs["end_time" + i].value;
				var start = startTime.substr(1, 4).replace(":", "");
				var end = endTime.substr(1, 4).replace(":", "");
				var minutesCalc = parseInt(end) - parseInt(start);
				if (startTime == endTime) {
					errors[i] = "Please enter start and end times that are different.";
					noErrors = false;
				}
			}

			if (date.length == 0 && (minutes == 0 || isNaN(minutes)) && (pages < 0 || isNaN(pages))) {
				errors[i] = "Please enter minutes, pages, and a date.";
				noErrors = false;
			} else if ((minutes == 0 || isNaN(minutes)) && (pages < 0 || isNaN(pages))) {
				errors[i] = "Please enter how many minutes and pages you read.";
				noErrors = false;
			} else if (minutes == 0 || isNaN(minutes)) {
				errors[i] = "Please enter how many minutes you read.";
				noErrors = false;
			} else if (!this.isOnlineText() && (pages < 0 || isNaN(pages))) {
				errors[i] = "Please enter how many pages you read.";
				noErrors = false;
			} else if (pages > BookLogger.MAX_LOG_PAGES) {
				errors[i] = "You're logging too many pages!";
				noErrors = false;
			} else if (minutes > BookLogger.MAX_LOG_MINUTES) {
				errors[i] = "You're logging too many minutes!";
				noErrors = false;
			} else if (date.length == 0) {
				errors[i] = "Please enter the day you logged your reading.";
				noErrors = false;
			} else if (startTime > endTime) {
				errors[i] = "Please enter a start time that comes before the end time.";
				noErrors = false;
			// } else if (minutesCalc != this.state.logMinutes[i]) {
			// 	errors[i] = "Something looks wrong. Please make sure your minutes, start and end times are correct.";
			// 	noErrors = false;
			}
		}
		this.setState({ errorsByRow: errors });
		return noErrors;
	}

	getData() {
		var logs = [];

		var excluded = this.shouldExclude();

		for (var i = 0; i < this.state.logRowCount; i++) {
			var minutes = this.refs["log_minutes" + i].refs["textfield"]["valueAsNumber"];
			var pages = this.refs["log_pages" + i].refs["textfield"]["valueAsNumber"];
			var date = $(this.refs["log_date" + i]).val();
			var timeZoneOffset = CurrentUser.get().time_zone_offset
			if (this.useDetailedForm()) {
				var tzName = jstz.determine().name();
				var startTime = this.refs["start_time" + i].value;
				var startTimeObject = date + " " + startTime;
				// var startTimeFormatted = moment.tz(startTimeObject, tzName).format();
				var startTimeFormatted = moment(startTimeObject).tz(tzName).format();

				var endTime = this.refs["end_time" + i].value;
				var endTimeObject = "" + date + " " + endTime;
				// var endTimeFormatted = moment.tz(endTimeObject, tzName).format();
				var endTimeFormatted = moment(endTimeObject).tz(tzName).format();

				var location = this.state.selectedLocation;
			}

			logs.push({
				minutes, pages, date, location, excluded,
				start_time: startTimeFormatted, 
				end_time: endTimeFormatted,
			});
		}
		return logs;
	}

	getDayOptions() {
		var user = CurrentUser.get();
		return DropDownOptions.Select.LastWeekDays({ days: user.prefs.back_log_date_period });
	}

	getTimeOptions() {
		return DropDownOptions.Select.Time();
	}

	isOnlineText() {
		return this.props.book.url != null;
	}

	showDetailedForm() {
		this.setState({ showDetailedForm: true, logRowCount: 1 })
	}

	useDetailedForm() {
		return CurrentUser.get().prefs.log_reading_detailed_view || this.state.showDetailedForm;
	}

	render() {
		var onlineTextClass = this.isOnlineText() ? 'onlineText' : ''
		
		var logRows = [];
		var row = -1;
		for (var i = 0; i < this.state.logRowCount; i++) {
			row += 1;
			if (_.includes(this.state.skipRowIndexes, row)) {
				i -= 1; continue;
			}
			if (this.state.logRowCount > 1) {
				var removeLogRow = (
					<button className="btn btn-link removeLogRow" onClick={ this.buildRemoveLogRow(row) }>
						<Glyphicon icon="remove" />
					</button>
				)
			}

			if (this.isOnlineText()) {
				var pagesInput = (
					<NumbersOnlyInput className="form-control logPages" type="hidden"
						ref={ "log_pages" + i } value="0" />
				);
			} else {
				var pagesInput = (
					<NumbersOnlyInput className="form-control logPages"
						ref={ "log_pages" + i } onKeyDown={ this.onKeyDown } />
				);
			}

			var user = CurrentUser.get();
			var showDetailedForm = this.useDetailedForm();

			if (showDetailedForm) {
				var detailedLabels = (
					<div className="quantityContainer">
						<NumbersOnlyInput className="form-control numbersOnly logMinutes" 
							ref={ "log_minutes" + i } onChange={ this.onChange.bind(this, i) } placeholder="Minutes..." />
						<NumbersOnlyInput className="form-control logPages"
							ref={ "log_pages" + i } onKeyDown={ this.onKeyDown } placeholder="Pages..." />
					</div>
				)
				var currentlySelectedSchool = this.state.selectedLocation == BookLogger.READ_AT_SCHOOL;
				var currentlySelectedHome = this.state.selectedLocation == BookLogger.READ_AT_HOME;

				var currentTimeOfDay = moment().format("A");
				if (currentTimeOfDay.includes("AM")) {
					var currentHour = moment().format("HH");
				} else {
					var currentHour = moment().format("H")
					var noZero = currentHour == "10" || "11" || "12";
					if (!noZero) {
						currentHour = moment().format("HH");
					}
				}

				var startDefault = currentHour +  ":00:00";

				if (this.state.logMinutes["log" + i]) {
					var startHour = this.refs["start_time" + i].value.substr(0, 2)
					var endValue = startHour + ":" + this.state.logMinutes["log" + i] + ":00";
				} else {
					var endValue = currentHour  + ":" + "15:00";
				}
				
				logRows.push(
					<div className="logRow clearfix" key={ "logRow" + row }>
						<div className="logError clearfix">{ this.state.errorsByRow[i] }</div>
						{ detailedLabels }
						<div className="whenContainer">
							<select className={`form-control selector dateSelector ${onlineTextClass}`} ref={ "log_date" + i } defaultValue={0}
								onChange={ this.changeDate.bind(this, row) }>
							    { this.getDayOptions() }
							</select>
							<select className="form-control selector timeSelector" ref={ "start_time" + i } 
								defaultValue={startDefault}>
							    { this.getTimeOptions() }
							</select>
							<select className="form-control selector timeSelector endTime" ref={ "end_time" + i } 
								defaultValue={endValue}>
								{ this.getTimeOptions() }
							</select>
						</div>
						<div className="placeContainer">
							<label>
			 					<input type="radio" checked={ currentlySelectedSchool }
			  						ref={ "log_location" + i } 
			  						onChange={ this.changeLocation.bind(this, BookLogger.READ_AT_SCHOOL) } />
		 						I read this at school
		 					</label>
		 					<label>
								<input type="radio" checked={ currentlySelectedHome  }
									ref={ "log_location" + i }
									onChange={ this.changeLocation.bind(this, BookLogger.READ_AT_HOME) } />
		 						I read this at home
		 					</label>
		 					{ removeLogRow }
						</div>
					</div>
				)	
			} else {
				logRows.push(
					<div className="logRow clearfix" key={ "logRow" + row }>
						<div className="logError clearfix">{ this.state.errorsByRow[i] }</div>
						<NumbersOnlyInput className="form-control numbersOnly logMinutes" 
							ref={ "log_minutes" + i } />
						
						{ pagesInput }

						<select className={`form-control dateSelector ${onlineTextClass}`} ref={ "log_date" + i } defaultValue={0}
							onChange={ this.changeDate.bind(this, row) }>
						    { this.getDayOptions() }
						</select>	

						{ removeLogRow }
					</div>
				)
			}
		}

		if (this.props.removeBook) {
			var removeBookButton = (
				<button className="btn btn-link removeBookRow" onClick={ this.removeBook }>
					<Glyphicon icon="remove" />
				</button>
			)			
		}

		if (!this.isOnlineText()) {
			var pagesLabel = <label className="logPages">Pages</label>;
		}

		var bookTitleArea = (
			<div className="titleSection">
				<span className="title">{this.props.book.title}</span>
			</div>
		)

		if (showDetailedForm) {
			var className = `bookLogger detailedBookLogger ${onlineTextClass}`
			var bookLoggingForm = (
				<div className="bookRow detailedBookRow clearfix">
					{ removeBookButton }
					<div className="logSection">
						<div className="logLabels clearfix">
							<label className="logMinutes">What</label>
							<label className="logDate">When</label>
							<label className="logPlace">Where</label>
						</div>
						<div className="logRows">
							{ logRows }
						</div>
						<div className="clearfix moreRowsContainer">
							<a className="moreRows" href="#" onClick={ this.addLogRow }>
								<Glyphicon icon="plus" />
								Log More for this Book
							</a>
						</div>
					</div>
				</div>	
			)
		} else {
			var className = `bookLogger ${onlineTextClass}`

			var showDetailedFormLink = (
				<a className={`showDetailedFormLink ${onlineTextClass}`} onClick={ this.showDetailedForm }>Show Advanced Log</a>
			)

			var bookLoggingForm = (
				<div className="bookRow clearfix">
					{ removeBookButton }
					<div className="logSection">
						<div className="logLabels clearfix">
							<label className="logMinutes">Minutes</label>
							{ pagesLabel }
							<label className="logDate">Date</label>
						</div>
						<div className="logRows">
							{ logRows }
						</div>
						<div className="clearfix moreRowsContainer">
							<a className={`moreRows ${onlineTextClass}`} href="#" onClick={ this.addLogRow }>
								<Glyphicon icon="plus" />
								Log More for this Book
							</a>
						</div>
					</div>
				</div>	
			)	
		}

		return (
			<div className={ className }>
				{ bookTitleArea }
				{ showDetailedFormLink }
				{ bookLoggingForm }
			</div>	
		)
	}
}

BookLogger.propTypes = StrictPropTypes({
	book: PropTypes.object.isRequired,
	removeBook: PropTypes.func
});

BookLogger.MAX_LOG_MINUTES = 480;
BookLogger.MAX_LOG_PAGES = 1000;
BookLogger.READ_AT_SCHOOL = "School";
BookLogger.READ_AT_HOME = "Home";

module.exports = BookLogger;


// WEBPACK FOOTER //
// ./modules/components/reading/books/BookLogger.js